import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { MarkdownComponent } from 'ngx-markdown';
import { LocaleDatePipe } from 'src/core/pipes';

@Component({
  selector: 'core-information-card',
  templateUrl: './information-card.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, LocaleDatePipe, MarkdownComponent],
})
export class InformationCardComponent {
  @Input() title!: string | null;
  @Input() image!: string | null;
  @Input() content!: string | null;
  @Input() author: string | null | undefined;
  @Input() buttonTitle: string | undefined;
  @Input() publishedDate: string | undefined;
  @Output() editInformationCardEvent = new EventEmitter<void>();
  @Output() removeInformationCardEvent = new EventEmitter<void>();
  @Output() readMoreInformationCardEvent = new EventEmitter<void>();

  editInformationCard() {
    this.editInformationCardEvent.emit();
  }

  removeInformationCard() {
    this.removeInformationCardEvent.emit();
  }

  readMoreInformationCard() {
    this.readMoreInformationCardEvent.emit();
  }
}
